import React from "react";
import { Link, DisabledPrompt, useRoute, useParams, useBCMSContext, BCMSRecord } from "@bcm-dev/bcms-vite";
import { Card } from "model";

import { UIPrimaryButton } from "components/ui/UIButton";
import { SVGAsset } from "res";

import "./styles.css";

/**
 * @function SetPinConfirmationView
 * @param cardType - This is the type of card that the pin is being set for (whether it is debit or credit). 
 * @param lastFour - This is the last four digits of the card that the pin is being set on. 
 * @return {React.Component}
 * @exported true
 * @description The third workflow step for the SetPinPage
 */
export default function SetPinConfirmationView(props) {
  const controller = useBCMSContext();
  BCMSRecord.globalControllerFor([ Card ], controller);

  const navigate = useRoute();
  const cardID = useParams().cardID ?? "0";

  const card = Card.initByID(cardID);
  const route = evt => navigate(`/home/recenttransactions/${ cardID }`);

  return(
    <div className="set-pin-confirmation-view text-center">
      <div className="card-success-icon-container row">
        <div className="framed-icon-container">
          <SVGAsset id="OutlineCardIcon" className="card-icon" />
        </div>
        <SVGAsset id="CheckmarkCircleIcon" className="check-mark" />
      </div>
      <p className="row pin-success-message"><b>PIN generation successful!</b></p>
      
      <p className="row">PIN has been set for { `${ card.type.charAt(0).toUpperCase() }${ card.type.slice(1) }` } ending in { card.maskedNumber }.</p>
      
      { card.type === "debit" && <p className="row">Use this PIN for ATM cash withdrawals and purchases that require card PIN.</p> }
      { card.type === "credit" && <p className="row">Use this PIN for ATM cash advances and purchases that require card PIN.</p> }

      <div className="flex-container center-row row align-center-container">
        <SVGAsset id="InformationIcon" className="left-inline-icon" />
        <p className="sub-text">Memorize your PIN. Do not share it with anyone.</p>
      </div>
      
      <div className="flex-container center-row row">
        <p>Have any questions?&nbsp;</p>
        <DisabledPrompt><Link>Contact Us</Link></DisabledPrompt>
      </div>

      <UIPrimaryButton text="Done" className="set-width" onClick={ route } />
    </div>
  );
}